export const phoneCodeByRegionIE = [
    {
        "Destination": "Abu Dhabi",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "AUH",
        "TSRID": "10559",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Ajman",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "31376",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Anguilla",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "ANU",
        "TSRID": "10598",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Antigua",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "ANU",
        "TSRID": "10430",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Aruba",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "AUA",
        "TSRID": "10553",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Bahamas",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "NAS",
        "TSRID": "31302",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Bali",
        "Region": "Indonesia",
        "code": "far-east-holidays",
        "Airport": "DPS",
        "TSRID": "11884",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Bangkok",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "BKK",
        "TSRID": "10877",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Barbados",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "BGI",
        "TSRID": "10785",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Bermuda",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "BDA",
        "TSRID": "10714",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Borneo",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "BKI",
        "TSRID": "10875",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Cancun & Caribbean Coast",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "CUN",
        "TSRID": "11623",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Cape Town",
        "Region": "South Africa",
        "code": "africa-holidays",
        "Airport": "CPT",
        "TSRID": "11537",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    },
    {
        "Destination": "Chiang Mai",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "CNX",
        "TSRID": "11498",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Cayman Islands",
        "Region": "Caribbean",
        "code": "far-east-holidays",
        "Airport": "GCM",
        "TSRID": "12422",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Da Nang",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "DAD",
        "TSRID": "11712",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Dominican Republic",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "PUJ",
        "TSRID": "15805",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Dubai",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "11945",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Dubai and the Emirates",
        "Region": "middle-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148974",
        "TSRID": "01342 331795",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "East Coast and Kuantan",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "KUL",
        "TSRID": "17425",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Fujairah",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "31535",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Grenada",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "GND",
        "TSRID": "12549",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Grenadines",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "SVD",
        "TSRID": "31350",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Hoi An",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "DAD",
        "TSRID": "31296",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Hong Kong",
        "Region": "Asia",
        "code": "far-east-holidays",
        "Airport": "HKG",
        "TSRID": "12808",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Hua Hin and Cha Am",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "BKK",
        "TSRID": "12785",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Johannesburg",
        "Region": "South Africa",
        "code": "africa-holidays",
        "Airport": "JNB",
        "TSRID": "13298",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    },
    {
        "Destination": "Kenya",
        "Region": "africa-holidays",
        "code": "0",
        "Airport": "rTapNumber164884",
        "TSRID": "01342 331 797",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    },
    {
        "Destination": "Khanom",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "USM",
        "TSRID": "31358",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Khao Lak",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "31293",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Koh Lanta",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "KBV",
        "TSRID": "43535",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Koh Phangan",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "USM",
        "TSRID": "31443",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Koh Samui",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "USM",
        "TSRID": "31445",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Koh Yao",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "31445",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Krabi",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "KBV",
        "TSRID": "13405",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Kuala Lumpur",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "KUL",
        "TSRID": "13769",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Langkawi",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "LGK",
        "TSRID": "13961",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Malaysia",
        "Region": "far-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148975",
        "TSRID": "01342 310 571",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Maldives",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "MLE",
        "TSRID": "19381",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Mauritius",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "MRU",
        "TSRID": "14672",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Mexico",
        "Region": "caribbean-holidays",
        "code": "0",
        "Airport": "rTapNumber164878",
        "TSRID": "01342 310596",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Mombasa",
        "Region": "Kenya",
        "code": "africa-holidays",
        "Airport": "MBA",
        "TSRID": "14286",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    },
    {
        "Destination": "Jamaica",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "MBJ",
        "TSRID": "31636",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    // {
    //     "Destination": "Jamaica",
    //     "Region": "Caribbean",
    //     "code": "caribbean-holidays",
    //     "Airport": "MBJ",
    //     "TSRID": "31636",
    //     "ClassName": "01 6649999",
    // "phoneHref": "",//     
    // "phone": "01 6649970"≥
    // },
    {
        "Destination": "Nha Trang",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "CXR",
        "TSRID": "30202",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    // {
    //     "Destination": "Jamaica",
    //     "Region": "Caribbean",
    //     "code": "caribbean-holidays",
    //     "Airport": "MBJ",
    //     "TSRID": "31636",
    //     "ClassName": "01 6649999",
    // "phoneHref": "",//     
    // "phone": "01 6649999"
    // },
    {
        "Destination": "Oman",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "MCT",
        "TSRID": "14327",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Pangkor",
        "Region": "Malaysia",
        "code": "far-east-holidays",
        "Airport": "KUL",
        "TSRID": "32681",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Phan Thiet",
        "Region": "Vietnam",
        "code": "far-east-holidays",
        "Airport": "SGN",
        "TSRID": "31478",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Phi Phi Islands",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "15550",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Phuket",
        "Region": "Thailand",
        "code": "far-east-holidays",
        "Airport": "HKT",
        "TSRID": "19391",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Qatar",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DOH",
        "TSRID": "11866",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Ras Al Khaimah",
        "Region": "Middle East",
        "code": "middle-east-holidays",
        "Airport": "DXB",
        "TSRID": "16567",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Reunion",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "RUN",
        "TSRID": "31356",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Cancun & Caribbean Coast",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "CUN",
        "TSRID": "11623",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    // {
    //     "Destination": "Jamaica",
    //     "Region": "Caribbean",
    //     "code": "caribbean-holidays",
    //     "Airport": "MBJ",
    //     "TSRID": "31636",
    //     "ClassName": "01 6649999",
    // "phoneHref": "",//     
    // "phone": "01 6649999"
    // },
    {
        "Destination": "Seychelles",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "SEZ",
        "TSRID": "31542",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "Singapore",
        "Region": "Asia",
        "code": "far-east-holidays",
        "Airport": "SIN",
        "TSRID": "16907",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "South Africa",
        "Region": "africa-holidays",
        "code": "0",
        "Airport": "rTapNumber164884",
        "TSRID": "01342 331 797",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    },
    {
        "Destination": "Sri Lanka",
        "Region": "Indian Ocean",
        "code": "indian-ocean-holidays",
        "Airport": "CMB",
        "TSRID": "31543",
        "ClassName": "01 6649999",
        "phoneHref": "016649980",
        "phone": "01 6649980"
    },
    {
        "Destination": "St Kitts and Nevis",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "SKB",
        "TSRID": "16943",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "St Lucia",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "UVF",
        "TSRID": "16984",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    {
        "Destination": "Sun City",
        "Region": "South Africa",
        "code": "africa-holidays",
        "Airport": "DUR",
        "TSRID": "15102",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    },
    {
        "Destination": "Thailand",
        "Region": "far-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148975",
        "TSRID": "01342 310 571",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Tobago",
        "Region": "Caribbean",
        "code": "caribbean-holidays",
        "Airport": "TAB",
        "TSRID": "17311",
        "ClassName": "01 6649999",
        "phoneHref": "016649970",
        "phone": "01 6649970"
    },
    // {
    //     "Destination": "Jamaica",
    //     "Region": "Caribbean",
    //     "code": "caribbean-holidays",
    //     "Airport": "MBJ",
    //     "TSRID": "31636",
    //     "ClassName": "01 6649999",
    //     "phoneHref": "016649999",
    //     "phone": "01 6649999"
    // },
    {
        "Destination": "Vietnam",
        "Region": "far-east-holidays",
        "code": "0",
        "Airport": "rTapNumber148975",
        "TSRID": "01342 310 571",
        "ClassName": "01 6649999",
        "phoneHref": "016649990",
        "phone": "01 6649990"
    },
    {
        "Destination": "Zanzibar",
        "Region": "Africa",
        "code": "africa-holidays",
        "Airport": "ZNZ",
        "TSRID": "19235",
        "ClassName": "01 6649999",
        "phoneHref": "016649940",
        "phone": "01 6649940"
    }
]